module.exports = __webpack_public_path__ + "img/order_icon.8753bb01.png";